/* eslint-disable camelcase */
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { withErrorBoundary } from "../../../../ErrorBoundary";
import { HtmlContent } from "../../../../HtmlContent";
import styles from "./Content.style";

const ContentStyled = styled.div((props) => ({ ...styles(props) }));

const Content = ({ className, text, lead, children, ...rest }) => (
    <ContentStyled className={className} {...rest}>
        {(lead || text) && (
            <div className="userProfileContent_primary">
                {lead && (
                    <HtmlContent
                        content={lead}
                        className="userProfileContent_lead"
                        wrapperComponent="div"
                    />
                )}
                {text && (
                    <HtmlContent
                        content={text}
                        className="userProfileContent_text"
                        wrapperComponent="div"
                    />
                )}
            </div>
        )}
        {children && <div className="userProfileContent_secondary">{children}</div>}
    </ContentStyled>
);

Content.propTypes = {
    className: PropTypes.string,
    lead: PropTypes.string,
    text: PropTypes.string,
};

Content.defaultProps = {
    className: undefined,
    lead: undefined,
    text: undefined,
};

export default withErrorBoundary(Content);
